import type { ArcgisIconType } from '@atom/types/arcgis';
import { getColorFromColorId } from '@atom/utilities/colorUtilities';

type ArcgisLayerIconProps = {
  iconType: ArcgisIconType;
  colorId: number;
  size?: string;
};

const ArcgisLayerIcon = ({
  iconType,
  colorId,
  size = '2.125rem',
}: ArcgisLayerIconProps) => {
  const color = getColorFromColorId(colorId);

  return (
    <svg
      data-cy={`arcgisLayerIcon-${iconType}`}
      width={size}
      height={size}
      viewBox="0 0 34 34"
      fill="none"
      aria-hidden
    >
      {iconType === 'SHAPE' && (
        <path
          d="M25.5068 24H9V13.666L19.457 9.30859L25.5068 24Z"
          fill={color}
          fillOpacity={0.2}
          stroke={color}
          strokeWidth={2}
        />
      )}
      {iconType === 'LINE' && (
        <rect x={8} y={15} width={18} height={4} rx={2} fill={color} />
      )}
      {iconType === 'POINT' && <circle cx={17} cy={17} r={4} fill={color} />}
    </svg>
  );
};

export default ArcgisLayerIcon;
